import { asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { mutationAccessTokenGenerate, mutationRequestSmsToken, mutationUserValidate } from './accessToken.gql.js';

var userPasswordValidationAsync = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(password, client) {
    var result, userValidate;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return client.mutate({
              mutation: mutationUserValidate,
              variables: {
                password: password
              }
            });
          case 3:
            result = _context.sent;
            userValidate = result.data.userValidate;
            return _context.abrupt("return", userValidate);
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            if (_context.t0.networkError) {
              _context.next = 12;
              break;
            }
            throw _context.t0;
          case 12:
            return _context.abrupt("return", null);
          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));
  return function userPasswordValidationAsync(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var requestSmsTokenAsync = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(client) {
    var result, smsRequestToken;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return client.mutate({
              mutation: mutationRequestSmsToken
            });
          case 3:
            result = _context2.sent;
            smsRequestToken = result.data.smsRequestToken;
            return _context2.abrupt("return", smsRequestToken);
          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](0);
            if (_context2.t0.networkError) {
              _context2.next = 12;
              break;
            }
            throw _context2.t0;
          case 12:
            return _context2.abrupt("return", null);
          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 8]]);
  }));
  return function requestSmsTokenAsync(_x3) {
    return _ref2.apply(this, arguments);
  };
}();
var generatAccessTokenAsync = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(giid, client, input) {
    var result, accessTokenGenerate;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return client.mutate({
              mutation: mutationAccessTokenGenerate,
              variables: {
                giid: giid,
                input: input
              }
            });
          case 3:
            result = _context3.sent;
            accessTokenGenerate = result.data.accessTokenGenerate;
            localStorage.setItem("".concat(giid, "-accessToken"), JSON.stringify(accessTokenGenerate));
            return _context3.abrupt("return", accessTokenGenerate);
          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](0);
            if (_context3.t0.networkError) {
              _context3.next = 13;
              break;
            }
            throw _context3.t0;
          case 13:
            return _context3.abrupt("return", null);
          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 9]]);
  }));
  return function generatAccessTokenAsync(_x4, _x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();

export { generatAccessTokenAsync, requestSmsTokenAsync, userPasswordValidationAsync };
